module.exports = __webpack_public_path__ + "static/img/potosi.e3ddc8f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/departamentales/potosi.jpg
// module id = jrqv
// module chunks = 1